import React, { Component } from 'react';
import { Cpu, Activity, Users, Calendar as CalendarIcon, FileText, LogOut } from 'lucide-react';
import './Sidebar.css';

class Sidebar extends Component {
    getInitials(name) {
        if (!name) return '';
        return name.charAt(0).toUpperCase();
    }

    render() {
        const { currentUser, activeTab, onTabChange, onLogout, hasPermission } = this.props;

        return (
            <aside className="sidebar">
                <div className="logo">
                    <Cpu size={28} />
                    <h2>ClinicPro</h2>
                </div>
                <div className="user-profile">
                    <div className="user-avatar">{this.getInitials(currentUser.name)}</div>
                    <div className="user-info">
                        <h3>{currentUser.name}</h3>
                        <span className="user-role">{currentUser.roleName}</span>
                    </div>
                </div>
                <nav className="nav-menu">
                    <button
                        onClick={() => onTabChange('dashboard')}
                        className={activeTab === 'dashboard' ? 'active' : ''}
                    >
                        <Activity size={20} /> <span>Dashboard</span>
                    </button>
                    <button
                        onClick={() => onTabChange('patients')}
                        className={activeTab === 'patients' ? 'active' : ''}
                        disabled={!hasPermission('viewPatient')}
                    >
                        <Users size={20} /> <span>Patients</span>
                    </button>
                    <button
                        onClick={() => onTabChange('appointments')}
                        className={activeTab === 'appointments' ? 'active' : ''}
                        disabled={!hasPermission('manageAppointments')}
                    >
                        <CalendarIcon size={20} /> <span>Appointments</span>
                    </button>
                    <button
                        onClick={() => onTabChange('reports')}
                        className={activeTab === 'reports' ? 'active' : ''}
                        disabled={!hasPermission('viewReports')}
                    >
                        <FileText size={20} /> <span>Reports</span>
                    </button>
                </nav>
                <div className="sidebar-footer">
                    <button className="logout-btn" onClick={onLogout}>
                        <LogOut size={16} /> Logout
                    </button>
                    <div className="version">v2.0.0 Refactored</div>
                </div>
            </aside>
        );
    }
}

export default Sidebar;
